// Configuration des types de blocs disponibles
export const BLOCK_TYPES = {
    text: {
        type: 'text',
        label: 'Texte',
        icon: 'mdi-text',
        component: 'TextBlock',
        properties: 'TextProperties',
        defaultData: {
            content: '',
            styles: {
                fontFamily: 'Arial, sans-serif'
            }
        }
    },
    image: {
        type: 'image',
        label: 'Image',
        icon: 'mdi-image',
        component: 'ImageBlock',
        properties: 'ImageProperties',
        defaultData: {
            src: '',
            alt: '',
            styles: {
                width: '100%',
                height: 'auto',
                borderRadius: '0px',
                objectFit: 'cover',
                alignment: 'center'
            }
        }
    },
    button: {
        type: 'button',
        label: 'Bouton',
        icon: 'mdi-cursor-default',
        component: 'ButtonBlock',
        properties: 'ButtonProperties',
        defaultData: {
            text: 'Cliquez ici',
            url: '#',
            styles: {
                backgroundColor: '#007bff',
                color: '#ffffff',
                alignment: 'center'
            }
        }
    },
    separator: {
        type: 'separator',
        label: 'Séparateur',
        icon: 'mdi-minus',
        component: 'SeparatorBlock',
        properties: 'SeparatorProperties',
        defaultData: {
            styles: {
                margin: '20px 0',
                backgroundColor: '#e0e0e0',
                height: '1px'
            }
        }
    }
}

// Fonction utilitaire pour créer un nouveau bloc
export function createBlock(type, customData = {}) {
    const blockConfig = BLOCK_TYPES[type]
    if (!blockConfig) {
        throw new Error(`Type de bloc inconnu: ${type}`)
    }

    return {
        id: generateBlockId(),
        type: type,
        ...blockConfig.defaultData,
        ...customData
    }
}

// Fonction pour générer un ID unique
export function generateBlockId() {
    return 'block_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9)
}

// Fonction pour obtenir la liste des types de blocs disponibles
export function getAvailableBlockTypes() {
    return Object.values(BLOCK_TYPES).map(config => ({
        type: config.type,
        label: config.label,
        icon: config.icon
    }))
}

// Fonction pour obtenir la configuration d'un type de bloc
export function getBlockConfig(type) {
    return BLOCK_TYPES[type]
}
